import React from 'react'
import { useState } from 'react'
const Readmorewords = props => {
  const { text } = props
  // const text = children ? children : ''
  const [isReadMore, setIsReadMore] = useState(true)
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore)
  }

  console.log(text, 'texttexttexttext')
  const css = {
    main: { display: 'inline-table', width: '20rem' },
  }
  const cssNowidth = {
    main: { display: 'inline-table' },
  }

  return (
    <p style={text.length >= 210 ? css.main : cssNowidth.main}>
      {isReadMore ? text.slice(0, 200) : text}
      <span onClick={toggleReadMore} className='read-or-hide'>
        {text.length >= 210 ? isReadMore ? <b>...read more</b> : <b>show less</b> : ''}
      </span>
    </p>
  )
}

export default Readmorewords
